import { Button } from "@/components/ui/button/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog/dialog";

type Props = {
	isShow: boolean;
	handleClickSaveButton: () => void;

	canClickSaveButton: boolean;

	children: React.ReactNode;
};

export const HPBSnackOrSnackBaseSettingsDialog = ({
	isShow, //
	handleClickSaveButton,

	canClickSaveButton,

	children,
}: Props) => {
	return (
		<Dialog open={isShow}>
			<DialogContent hideCloseButton={true} className="max-w-[720px]">
				<div className="space-y-8 overflow-y-auto">
					<DialogHeader>
						<DialogTitle>基本情報設定</DialogTitle>
						<DialogDescription>
							スナックの基本情報を設定します。タイトル、サムネイル、説明、スラッグ（URL）を設定できます。
						</DialogDescription>
					</DialogHeader>

					<div className="space-y-16">
						<div className="space-y-6 px-1">{children}</div>
						<div className="flex justify-center">
							<Button
								size="xl"
								variant={canClickSaveButton ? "default" : "disabled"}
								onClick={handleClickSaveButton}
							>
								保存
							</Button>
						</div>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	);
};

HPBSnackOrSnackBaseSettingsDialog.displayName = "HPBSnackOrSnackBaseSettingsDialog";
